/* Maison Matcha — landing B2B « Les Stories » : tiroir et formulaire en étapes.
   Dépend de assets/mm-b2b-core.js (window.MMB2B). L'envoi réel est branché en tâche 8. */
(function () {
  'use strict';
  const C = window.MMB2B;
  if (!C) return;
  const ORDER = ['type', 'current', 'volume', 'intent', 'contact'];
  const ERROR_TEXT = { required: 'Champ obligatoire', email: 'Adresse email invalide', phone: 'Numéro incomplet (9 chiffres minimum)' };

  function setInert(el, on) { if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert'); }

  function storedUtm() {
    let utm = C.readUtm(window.location.search);
    try {
      if (Object.keys(utm).length) sessionStorage.setItem('mmb_utm', JSON.stringify(utm));
      else utm = JSON.parse(sessionStorage.getItem('mmb_utm') || '{}');
    } catch (e) { /* stockage indisponible (navigation privée) : on garde ce que dit l'URL */ }
    return utm;
  }

  /* Pixel Meta direct : le pixel de l'app Shopify tourne dans un bac à sable, fbq n'existe pas dans la page
     (même amorce que snippets/meta-lead-event.liquid). Le suivi publicitaire ne doit jamais bloquer la page. */
  function pixel(pixelId, userData) {
    if (!window.fbq) {
      !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }
    // Un second init avec les coordonnées met à jour la correspondance avancée du pixel déjà initialisé.
    if (userData) window.fbq('init', String(pixelId), userData);
    else if (!window.__mmbPixelInit) window.fbq('init', String(pixelId));
    window.__mmbPixelInit = true;
  }

  /* Consentement cookies (Pandectes → API de confidentialité Shopify) : marketing accepté ou non. */
  function marketingAllowed() {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed());
    } catch (e) { return false; }
  }

  function onMarketingConsent(cb) {
    let fired = false;
    const go = () => { if (!fired && marketingAllowed()) { fired = true; cb(); } };
    go();
    if (fired) return;
    document.addEventListener('visitorConsentCollected', go);
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) go(); });
      }
    } catch (e) { /* API indisponible : on attend l'événement de consentement */ }
  }

  /* Arrivée sur la page : ViewContent « B2B professionnels », pour l'audience « a vu la page pro »
     (Meta ne garde pas le chemin des URL de ce site, une audience par URL est impossible). */
  function trackView(pixelId) {
    if (!pixelId) return;
    onMarketingConsent(() => {
      try {
        if (window.__mmbViewSent) return;
        window.__mmbViewSent = true;
        pixel(pixelId);
        window.fbq('track', 'ViewContent', { content_name: 'B2B professionnels', content_category: 'Landing pro' });
      } catch (e) { /* idem */ }
    });
  }

  /* Envoi réussi : Lead, avec email, téléphone, prénom et nom (hachés par le pixel) si le marketing est accepté. */
  function trackLead(pixelId, payload) {
    if (!pixelId) return;
    try {
      pixel(pixelId, marketingAllowed() ? C.matchData(payload) : null);
      window.fbq('track', 'Lead', { content_name: 'B2B professionnels', content_category: (payload && payload.type) || '' });
    } catch (e) { /* idem */ }
  }

  function initForm(root) {
    const drawer = root.querySelector('[data-mmb-drawer]');
    const form = root.querySelector('[data-mmb-form]');
    if (!drawer || !form) return;
    let raw = {};
    try { raw = JSON.parse(root.getAttribute('data-mmb-config') || '{}'); } catch (e) { raw = {}; }
    const cfg = C.normalizeConfig(raw);
    trackView(raw.pixelId);
    const steps = Array.from(form.querySelectorAll('[data-step]'));
    const reveals = Array.from(form.querySelectorAll('[data-reveal-of]'));
    const bar = drawer.querySelector('[data-mmb-bar]');
    const count = drawer.querySelector('[data-mmb-count-steps]');
    const backBtn = drawer.querySelector('[data-mmb-back]');
    const range = form.querySelector('[data-mmb-range]');
    let state = {};
    let cur = 'type';
    let hist = [];
    let opener = null;
    let openedAt = 0;
    const utm = storedUtm();
    let sending = false;

    function chrome() {
      const i = ORDER.indexOf(cur);
      if (bar) bar.style.width = i < 0 ? '100%' : ((i + 1) / ORDER.length * 100) + '%';
      if (count) count.textContent = i < 0 ? '' : (i + 1) + ' / ' + ORDER.length;
      if (backBtn) backBtn.hidden = !(i > 0);
      drawer.dataset.at = cur;
    }

    function focusStep(step) {
      const title = step && step.querySelector('.mmb-qt, .mmb-thx-t');
      if (title) setTimeout(() => title.focus({ preventScroll: true }), 80);
    }

    function show(name, isBack) {
      if (name === cur) return;
      const from = form.querySelector('[data-step="' + cur + '"]');
      const to = form.querySelector('[data-step="' + name + '"]');
      if (!to) return;
      if (!isBack && ORDER.indexOf(cur) >= 0) hist.push(cur);
      from.classList.remove('is-current');
      from.classList.add('is-leaving');
      setInert(from, true);
      setTimeout(() => from.classList.remove('is-leaving'), 650);
      to.classList.add('is-current');
      setInert(to, false);
      cur = name;
      chrome();
      focusStep(to);
    }

    function next() { const i = ORDER.indexOf(cur); if (i >= 0 && i < ORDER.length - 1) show(ORDER[i + 1]); }
    function back() { const prev = hist.pop(); if (prev) show(prev, true); }

    function updVolume() {
      if (!range) return;
      const t = C.tier(parseInt(range.value, 10), cfg);
      state.drinks_per_day = t.drinksPerDay;
      form.querySelectorAll('[data-mmb-fout]').forEach((el) => {
        const key = el.getAttribute('data-mmb-fout');
        el.textContent = key === 'n' ? t.drinksPerDay : key === 'volume' ? C.formatVolume(t.gramsPerMonth) : C.formatEur(t.costPerDrink);
      });
      range.style.setProperty('--p', ((Number(range.value) - Number(range.min)) / (Number(range.max) - Number(range.min)) * 100) + '%');
      range.setAttribute('aria-valuetext', t.drinksPerDay + ' boissons par jour');
    }

    function reveal(key, on) {
      reveals.filter((r) => r.getAttribute('data-reveal-of') === key).forEach((r) => { r.classList.toggle('is-shown', on); setInert(r, !on); });
    }

    function contactFields() {
      const out = {};
      C.CONTACT_FIELDS.forEach((name) => { const input = form.elements[name]; out[name] = input ? input.value : ''; });
      return out;
    }

    function markErrors(errors) {
      C.CONTACT_FIELDS.forEach((name) => {
        const input = form.elements[name];
        if (!input) return;
        const wrap = input.closest('.mmb-field');
        wrap.classList.remove('is-bad');
        void wrap.offsetWidth; // relance l'animation de secousse
        wrap.classList.toggle('is-bad', !!errors[name]);
        input.setAttribute('aria-invalid', errors[name] ? 'true' : 'false');
        const msg = wrap.querySelector('.mmb-err');
        if (msg) msg.textContent = !errors[name] ? '' : errors[name] === 'required' ? ERROR_TEXT.required : ERROR_TEXT[name] || ERROR_TEXT.required;
      });
      const first = C.CONTACT_FIELDS.find((name) => errors[name]);
      if (first) form.elements[first].focus();
    }

    function collect() {
      return C.buildPayload(state, utm, {
        config: cfg,
        pageUrl: window.location.href.split('#')[0],
        referrer: document.referrer,
        elapsedMs: Date.now() - openedAt
      });
    }

    function done(payload) {
      form.querySelectorAll('[data-bind]').forEach((el) => { el.textContent = payload[el.getAttribute('data-bind')] || ''; });
      const recap = form.querySelector('[data-mmb-recap]');
      if (recap) {
        const volume = payload.drinks_per_day === '' ? 'Volume à définir' : payload.drinks_per_day + ' boissons / jour';
        recap.textContent = [payload.type, volume, payload.intent].filter(Boolean).join(' · ');
      }
      show('thanks');
    }

    function fail(payload) {
      const link = form.querySelector('[data-mmb-mailto]');
      if (link) link.href = C.mailtoHref(raw.fallbackEmail || '', payload);
      show('error');
    }

    const SCRIPT_RE = /^https:\/\/script\.google\.com\/macros\/s\/[\w-]+\/exec$/;

    async function send(payload) {
      if (sending) return;
      const url = String(raw.scriptUrl || '').trim();
      if (!SCRIPT_RE.test(url)) { fail(payload); return; }
      sending = true;
      const btn = form.querySelector('[data-mmb-submit]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      const ctrl = new AbortController();
      const timer = setTimeout(() => ctrl.abort(), 12000);
      try {
        const res = await fetch(url, { method: 'POST', body: JSON.stringify(payload), signal: ctrl.signal });
        const data = await res.json();
        if (!data || data.ok !== true) throw new Error((data && data.error) || 'refus');
        trackLead(raw.pixelId, payload);
        done(payload);
      } catch (err) {
        fail(payload);
      } finally {
        clearTimeout(timer);
        sending = false;
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      }
    }

    function focusables() {
      return Array.from(drawer.querySelectorAll('button, a[href], input'))
        .filter((el) => !el.closest('[inert]') && !el.disabled && !el.hidden && el.offsetParent !== null && !el.classList.contains('mmb-hp'));
    }

    function open(trigger) {
      if (root.classList.contains('is-open')) return;
      opener = trigger || document.activeElement;
      const calc = root.querySelector('[data-mmb-calc]');
      const preset = root.dataset.activeType === 'calculator' && calc && range;
      drawer.classList.toggle('is-preset', !!preset);
      if (preset) { range.value = calc.value; updVolume(); }
      root.classList.add('is-open');
      setInert(drawer, false);
      document.documentElement.classList.add('mmb-lock');
      if (!openedAt) openedAt = Date.now(); // le délai anti-robot compte depuis la première ouverture, pas depuis une réouverture
      root.dispatchEvent(new CustomEvent('mmb:drawer', { detail: { open: true } }));
      focusStep(form.querySelector('[data-step="' + cur + '"]'));
    }

    function reset() {
      state = {};
      openedAt = 0;
      hist = [];
      form.reset();
      form.querySelectorAll('.is-on').forEach((b) => { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
      form.querySelectorAll('.mmb-field.is-bad').forEach((w) => w.classList.remove('is-bad'));
      reveals.forEach((r) => { r.classList.remove('is-shown'); setInert(r, true); });
      steps.forEach((s) => { s.classList.remove('is-current', 'is-leaving'); setInert(s, true); });
      const first = form.querySelector('[data-step="type"]');
      first.classList.add('is-current');
      setInert(first, false);
      cur = 'type';
      chrome();
      updVolume();
    }

    function close() {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      setInert(drawer, true);
      document.documentElement.classList.remove('mmb-lock');
      root.dispatchEvent(new CustomEvent('mmb:drawer', { detail: { open: false } }));
      if (cur === 'thanks') setTimeout(reset, 450);
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }

    root.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-mmb-open]');
      if (trigger) { e.preventDefault(); open(trigger); return; }
      if (e.target.closest('[data-mmb-close]')) { close(); return; }
      if (e.target.closest('[data-mmb-back]')) back();
    });

    form.addEventListener('click', (e) => {
      const pick = e.target.closest('[data-pick]');
      if (pick) {
        const key = pick.getAttribute('data-pick');
        form.querySelectorAll('[data-pick="' + key + '"]').forEach((b) => {
          const on = b === pick;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        state[key] = pick.getAttribute('data-value');
        reveal(key, pick.hasAttribute('data-reveal'));
        if (pick.hasAttribute('data-auto')) setTimeout(next, 340);
        return;
      }
      if (e.target.closest('[data-next]')) {
        if (cur === 'current' && form.elements.brand_current) state.brand_current = form.elements.brand_current.value.trim();
        if (cur === 'volume') updVolume();
        next();
        return;
      }
      if (e.target.closest('[data-unsure]')) { state.drinks_per_day = ''; next(); return; }
      if (e.target.closest('[data-mmb-retry]')) send(collect());
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (cur !== 'contact') return;
      const fields = contactFields();
      const check = C.validateContact(fields);
      markErrors(check.errors);
      if (!check.ok) return;
      Object.assign(state, fields);
      state.hp = form.elements.hp ? form.elements.hp.value : '';
      send(collect());
    });

    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      const items = focusables();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      // Focus sur le tiroir lui-même (clic sur du texte) ou égaré : on le ramène dans la boucle.
      if (!items.includes(document.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    if (range) range.addEventListener('input', updVolume);
    steps.forEach((s) => setInert(s, !s.classList.contains('is-current')));
    reveals.forEach((r) => setInert(r, true));
    chrome();
    updVolume();
  }

  document.querySelectorAll('[data-mmb]').forEach(initForm);
})();
